import React from 'react';
import {DATA_POINT_DESCRIPTION, FileDataSummary, formatDataCount} from '../../utils/fileDataSummary';

const FileDataCounts: React.FC<{data: FileDataSummary}> = ({data}) => (
  <span className="inline-flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] tabular-nums" title={DATA_POINT_DESCRIPTION}>
    {data.dataSummaryStatus === 'indexed' ? <>
      <span><strong>{formatDataCount(data.compoundCount)}</strong> compounds</span>
      <span className="text-blue-700 dark:text-blue-300"><strong>{formatDataCount(data.biologicalDataPointCount)}</strong> bio data points</span>
      {!!data.biologicalEntityCount && <span><strong>{formatDataCount(data.biologicalEntityCount)}</strong> biological entities</span>}
    </> : <span className="text-gray-500">{data.dataSummaryStatus === 'processing' ? 'Biology indexing pending' : data.dataSummaryStatus === 'unavailable' ? 'Biology counts unavailable' : 'Biology not indexed'}</span>}
  </span>
);
export default FileDataCounts;
